import React, { useState } from 'react';
import { View } from 'react-native-web';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button } from 'app/src/elements/buttons';
import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';
import { Text, Title } from 'app/src/styles';

import { FIELDS } from './new';
import { UPDATE_USER } from './queries';

const EditUser = ({ user, setShow, refetch, projects }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource: user })
  });

  const [updateUser] = useMutation(UPDATE_USER, {
    onCompleted: () => {
      refetch();
      setShow(false);
    },
    onError: () => {
      setFormStatus(null);
    }
  });

  const onSubmit = input => {
    setFormStatus('submitting');

    updateUser({
      variables: { id: user.id, ...prepareInput(input, FIELDS) }
    });
  };

  const fields = { ...FIELDS };

  fields.projectId = {
    ...fields.projectId,
    select: [{ value: '', label: 'Select' }, ...projects],
  };

  fields.password = {
    ...fields.password,
    label: 'Change Password',
    rules: {},
    hint: 'Leave blank to not change',
  };

  return (
    <Modal title="Update Email Account" setShow={setShow}>
      <Text style={{ fontWeight: 600 }}>
        Note: Chaning the username or project will cause the user's existing
        mail to disappear.
      </Text>

      <Text style={{ fontWeight: 600, marginBottom: 20 }}>
        The folder would need to manually moved on the server.
      </Text>

      <Fields fields={fields} control={control} errors={errors} />

      <Button
        label="Update Email Account"
        onPress={handleSubmit(onSubmit)}
        disabled={'submitting' === formStatus}
        wide
      />
    </Modal>
  );
};

export default EditUser;
